<template>
    <nav>
        <v-app-bar clipped app flat height='50px'>
          <v-app-bar-nav-icon color="#B45C5C" @click="drawer = !drawer"></v-app-bar-nav-icon>
          <v-toolbar-title class="headline text-uppercase">
              <span class="title">Peer Cover</span>
              </v-toolbar-title>
          <v-spacer></v-spacer>

        <v-badge class="mr-3" color="red" overlap right dot="true" bordered="true">
          <template v-slot:badge>
            <span class="ma-0 pa-0">{{Bell}}</span>
          </template>
          <v-btn class="" small flat icon router-link to="/notifications">
            <v-icon>mdi-bell</v-icon>
          </v-btn>
        </v-badge>
          <div>
            <v-avatar size="30px" class="mr-1">
              <v-img class="" :src="getImgUrl(Images.profile_img_url)"  lazy-src="/profile_pic.svg"></v-img>
            </v-avatar>
            <span class="text--black">Hi, {{this.$store.state.community.logindetails.firstname}}</span>
          </div>  
        </v-app-bar>

        <!-- navigation drawer -->
        <v-navigation-drawer app clipped-left v-model="drawer" class="nav" floating>     
          <v-layout column align-center>
                <v-flex class="">
                    <div class="pa-3 mr-2">
                      <v-img src='/peer.png' contain  height='80'></v-img>
                    </div>
                </v-flex>
          </v-layout>   
          <v-list dense nav>
            <v-list-item  data-intro="Welcome to your dashboard. Gives you overview information of the system" data-position="right" router-link to="/dashboard">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#7A7674; font-size:14px" >
                  DASHBOARD
                </v-list-item-title>
              </v-item-content>
            </v-list-item>
            <v-list-item router-link to="/transactions">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-finance</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#7A7674; font-size:14px">
                  TRANSACTIONS
                </v-list-item-title>
              </v-item-content>
            </v-list-item>
            
            <v-list-item router-link to="/community">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-google-circles-communities</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#7A7674; font-size:14px">
                  COMMUNITY
                </v-list-item-title>
              </v-item-content>
            </v-list-item>
            <v-list-item router-link to="/member">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-account-group</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#7A7674; font-size:14px">
                  MEMBERS
                </v-list-item-title>
              </v-item-content>
            </v-list-item>
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-icon class="ml-5">
                  <v-icon color="#B45C5C">mdi-account</v-icon>
                </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title style="color:#7A7674; font-size:14px">AGENTS</v-list-item-title>
                  </v-list-item-content>
              </template>
              <v-list-item class="ml-7" v-if='this.$store.state.community.logindetails.is_Admin === 1' router-link to="/consultants">
                <v-list-item-icon>
                  <v-icon color="#B45C5C">mdi-account-group</v-icon>
                </v-list-item-icon>
                <v-item-content >
                  <v-list-item-title style="color:#7A7674; font-size:14px">
                    CONSULTANTS
                  </v-list-item-title>
                </v-item-content>
                
              </v-list-item>

              <v-list-item router-link to="/marketing_consultants" class="ml-7">
                <v-list-item-icon>
                  <v-icon color="#B45C5C">mdi-account-tie-voice</v-icon>
                </v-list-item-icon>
                <v-item-content  >
                  <v-list-item-title style="color:#7A7674; font-size:14px">
                    MARKETERS
                  </v-list-item-title>
                </v-item-content>
              </v-list-item>

              <v-list-item router-link to="/loss_assessors" class="ml-7">
                <v-list-item-icon>
                  <v-icon color="#B45C5C">mdi-account-supervisor-circle</v-icon>
                </v-list-item-icon>
                <v-item-content  >
                  <v-list-item-title style="color:#7A7674; font-size:14px">
                    ASSESSORS
                  </v-list-item-title>
                </v-item-content>
              </v-list-item>
              
            </v-list-group>
            <v-list-item router-link to="/report">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-clipboard-file</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#7A7674; font-size:14px">
                  REPORT
                </v-list-item-title>
              </v-item-content>
            </v-list-item>
              <v-list-item router-link to="/claims">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-human-greeting</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#7A7674; font-size:14px">
                  CLAIMS
                </v-list-item-title>
              </v-item-content>
            </v-list-item>
               <v-list-item router-link to="/profile">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-account</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#7A7674; font-size:14px">
                  PROFILE
                </v-list-item-title>
              </v-item-content>
            </v-list-item>
             <v-list-item router-link to="/subscriptions">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-account-key</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#7A7674; font-size:14px">
                  POLICY
                </v-list-item-title>
              </v-item-content>
            </v-list-item>
            <!-- <v-list-item @click="startIntro()">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-help</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#7A7674; font-size:14px">
                  Help
                </v-list-item-title>
              </v-item-content>
            </v-list-item> -->
             <v-list-item v-on:click="logout()">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-logout</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#7A7674; font-size:14px">
                  Sign Out
                </v-list-item-title>
              </v-item-content>
            </v-list-item>
            
           </v-list>
        </v-navigation-drawer>
    </nav>
   
</template>

<script>
import "intro.js/minified/introjs.min.css";

export default {
    data(){
      return{
        drawer: null,
        // url:"http://192.168.1.115:3000",
        // url:"https://cover-my-car.herokuapp.com",
        url:"https://res.cloudinary.com/dmnghlyic/image/upload/v1587634815/",
        admins: [
          ['Management', 'people_outline'],
          ['Settings', 'settings'],
        ],
      }
    },
    computed:{
      Images(){
        return this.$store.state.community.logindetails
      },
      Bell(){
        return this.$store.state.consultants.bellcount
      }
    },
    methods:{
       startIntro() {
          const introJS = require("intro.js");
          introJS.introJs().start();
          $(".introjs-tooltip").css({"background-color" : "black", "color" : "white", "opacity": 0.9}); 
          $(".introjs-arrow.top").css("border-bottom-color" , "black")
        },
      logout(){
        this.$store.dispatch("AUTH_LOGOUT")
        .then((success)=>{
          this.$router.push('/login');
        })
        .catch((error)=>{
          console.log(error);
        })
      },
      getImgUrl(pic) {
        if(pic==="" || pic===null){
          let image="/profile_pic.svg"
          return image
        }else{
          let weblink = this.url;
          return weblink+pic;
        }
        
    },
  },
  created(){
    this.$store.dispatch("BellCount",this.$store.state.community.logindetails.consultant_id)
    .then((success)=>{
      console.log(success)
    })
    .catch((error)=>{
      console.log(error)
    });
  }
}
</script>

<style scoped>
*{
   font-family: 'Lato';
}
.v-list .v-list-item--active{
  background-color: #BCFF9E;
}
.nav{
    box-shadow: 0px 14px 8px rgba(0, 0, 0, 0.25);
}
.title{
     color:#08911B;
}
.v-badge__badge{
  width:auto;
  border-radius: 12px;
  padding: 5px;
}
.dot {
  height: 25px;
  width: 25px;
  background-color: #bbb;
  border-radius: 50%;
}
</style>